<template>
  <div id="index">

    <div class="container">
      <div class="app_header">
        <Header :activeIndex="'/'" />
      </div>
      <div class="app_main">

        <!-- index_banner -->
        <div class="index_banner" v-loading="loading">
          <el-carousel trigger="click" height="660px">
            <el-carousel-item v-for="(banner,index) in banners" :key="index">
              <div class="banner_loop" :style="{backgroundImage: 'url(' +banner.url + ')'}">
                <div class="bl_center thewidth_center">
                  <!-- <div class="__title">Welcome CRYGRP!</div> -->
                  <div class="__desc">Welcome to CRYGRP for CRYstallographic symmetry GRouPs and related datasets/tools/results in crystalline materials.</div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- /index_banner -->

        <!-- index_content -->
        <div class="index_content thewidth_center">
          
        </div>
        <!-- /index_content -->
        
        

      </div>
      <div class="app_footer">
        <Footer />
      </div>
    </div>

  </div>
</template>
<script>
import { postData } from "../api/index";

export default {
  name: 'Index',
  components: {
  },
  data() {
    return {
      loading: false,
      banners:[]
    }
  },
  created() {
    this.getBanners();
  },
  mounted() {
  },
  methods: {

    // 获取列表
    getBanners(){
      this.loading = true;
      let query = {
        page:1,
        pageSize:999
      }
      postData("/home/page",query).then(res=>{
        console.log(res);
        if(res.success == true){
          let data = res.data;
          this.banners = data.list;
          this.loading = false;
        }else{
          this.$message.error(res.message)
        }
      })
    },

  }
}
</script>
<style lang="less" scoped>
.index_banner{

}
.banner_loop{
  width: 100%;
  height: 660px;
  background-color: #000;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  .bl_center{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 40%;
    text-align: center;
    .__title{
      font-size: 45px;
      line-height: 60px;
      color: rgba(#fff,0.8);
      font-weight: 400;
      // text-transform: uppercase;
      margin-bottom: 20px;
    }
    .__desc{
      font-size: 25px;
      line-height: 36px;
      color: rgba(#fff,0.8);
      font-weight: 400;
      padding: 0 10%;
    }
  }
}
.index_content{

}
</style>